export const environment = {
			production: false,
			apiEnvironment: 'Dev',
			apiRoot: 'https://api.trbportal.com',
			nodeApiRoot: 'https://api.fromdev5.jcarapia.sandbox.portal.trb.bank',
			cognitoRegion: 'us-east-1',
			cognitoUserPoolId: 'us-east-1_DqiwKmEQy',
			cognitoAppClientId: '5eckde4ksaj7llppbojpbchda5',
			webSocketApiUri: 'wss://websocket.fromdev5.jcarapia.sandbox.internal.trb.bank/',
			clientAppUri: 'https://portal5.jcarapia.sandbox.portal.trb.bank',
			extIdentityProviderRoot: 'https://auth.fromdev5.jcarapia.sandbox.portal.trb.bank',
			plaidVerificationTemplate: 'idvtmp_51U3nsbLGA96V7',
			plaidEnv: 'sandbox',
			consoleLogLevel: 'NONE'
		};
		